export class AccountOrganizationAlreadyExistsError extends Error {
  constructor(message: string, readonly accountId: string, readonly organizationId: string) {
    super(message);
  }
}
